import { FC, HTMLAttributes } from 'react';
import { TiArrowSortedUp, TiArrowSortedDown } from 'react-icons/ti';
import './FilterArrowsIcon.scss';
import classNames from 'classnames';

export const FilterArrowsIcon: FC<HTMLAttributes<HTMLElement>> = (props) => {
    return (
        <div
            {...props}
            className={classNames('filter-arrows-icon', props.className)}
        >
            <TiArrowSortedUp viewBox='0 -4 24 24' />
            <TiArrowSortedDown viewBox='0 8 24 24' />
        </div>
    );
};
